import React from 'react';
import { Note } from './styled';

interface Props {
  typePasarella?: string;
}

const DISCLAIMER = {
  'purchase-print': 'Recuerda que la publicación del aviso impreso está sujeto a disponibilidad y a la fecha de cierre de la edición seleccionada. Asimismo, si la publicación se da después del horario de cierre, el aviso se publicará en la siguiente fecha más cercana. Para el caso de ediciones de Sábados y Domingos fuera de la fecha de cierre, la fecha de publicación será la siguiente semana más cercana. Ten en cuenta que una vez realizado el envío de tu aviso, este no podrá ser editado.',
  'purchase-web': 'Recuerda que una vez pagado tu aviso solo podrás editar los campos de precio y descripción.'
}

export const Disclaimer: React.FC<Props> = ({ typePasarella }) => (
  <Note>
    <strong>NOTA: </strong>
    {
      DISCLAIMER[typePasarella] ?
        DISCLAIMER[typePasarella]
        :
        DISCLAIMER['purchase-print']
    }
  </Note>
);
